export enum FiltersAutoRegType {
  COOKIE = 'cookie',
  TWF = 'twf',
  NO_TWF = 'noTwf',
  FB_TOOLS = 'fbTools',
  CREATE_PROFILE_AP = 'createProfileAP',
  EXAMINATION_ACC = 'examinationAcc'
}
